import React from "react";

interface Props {
  joint: { name: string; img: string };
}

// A joint colour: its number next to a strip of its texture.
export const JointRow: React.FC<Props> = ({ joint }) => (
  <span className="flex w-full min-w-0 items-center gap-3">
    <span className="w-10 shrink-0 font-medium tabular-nums">{joint.name}</span>
    <span
      aria-hidden="true"
      className="h-6 min-w-16 flex-1 rounded-sm border border-black/5 bg-repeat-x"
      style={{ backgroundImage: `url(${joint.img})`, backgroundSize: "auto 100%" }}
    />
  </span>
);
